import React from 'react';
import SectionWrapper from '../ui/SectionWrapper';
import { FiCheckCircle } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const Philosophy = () => {
  const principles = [
    {
      title: "Security by Design",
      text: "Security isn't a patch you apply at the end. I integrate trust and safety protocols from the very first whiteboard session."
    },
    {
      title: "Pragmatic Execution",
      text: "Startups don't have time for academic theory. I focus on solutions that are robust enough to work and simple enough to maintain."
    },
    {
      title: "Cross-Functional Translation",
      text: "I speak both 'engineer' and 'executive'. I bridge the gap between technical constraints and business goals to keep teams aligned."
    },
    {
      title: "Data-Driven Decisions",
      text: "Instinct is good; data is better. I build feedback loops into every system to ensure we are solving the right problems."
    }
  ];

  return (
    <SectionWrapper id="philosophy" className="bg-slate-900 text-white">
      <div className="grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6">How I Work</h2>
          <p className="text-slate-300 text-lg leading-relaxed mb-8">
            Building trust systems requires more than just code—it requires a philosophy of responsibility. In every collaboration, I bring a mindset that values clarity, speed, and integrity.
          </p>
          <div className="p-6 bg-slate-800 rounded-xl border border-slate-700">
            <p className="italic text-slate-200 text-lg">
              "Marjo brings a level of clarity to complex security problems that is rare in this industry. She doesn't just find holes; she builds foundations."
            </p>
          </div>
        </div>
        <div className="grid sm:grid-cols-2 gap-6">
          {principles.map((item, i) => (
            <div key={i} className="p-6 bg-slate-800/50 rounded-xl border border-slate-700/50 hover:bg-slate-800 transition-colors">
              <SafeIcon icon={FiCheckCircle} className="text-teal-400 text-2xl mb-4" />
              <h3 className="text-xl font-bold text-white mb-2">{item.title}</h3>
              <p className="text-slate-400 text-sm leading-relaxed">
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </SectionWrapper>
  );
};

export default Philosophy;